export default __webpack_public_path__ + "static/media/BINANCE.c2364ac7.svg";